import { LocalStoreKeysEnum } from "../../../models/enums/localstore-keys.enum";
import Inspection from "../../../models/inspection.entity";
import http from "../../../services/http.service";
import inspectionPayloadService from "./inspection-payload.service";

class UserTransactionService {
  public create = async (inspection: Inspection, isSicredi: boolean, documentType: string) => {
    let payload = null;

    if (isSicredi) {
      payload = inspectionPayloadService.formatPayloadBetweenCPForCNPJ(inspection, documentType);
    } else {
      payload = inspectionPayloadService.formatPayloadSimplesCPF(inspection);
    }

    const localInspectionId = localStorage.getItem(LocalStoreKeysEnum.LABEL_INSPECTION_ID);

    if (localInspectionId) {
      payload.inspection_id = localInspectionId;
    }

    return http.post('/v1/user-transaction', payload)
      .catch((error) => {
        const { data } = error.response;
        return Promise.reject(data.errors);
      });
  }
}

export default new UserTransactionService();
